<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.currency_change_risk"
            :label="$t('acknowledgements.currency_change_risk')"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'currency_change_risk')"
            name="acknowledgements.currency_change_risk"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.anti_money_laundering"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'anti_money_laundering')"
            :label="$t('acknowledgements.anti_money_laundering')"
            name="acknowledgements.anti_money_laundering"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.acknowledgements.own_account"
            :required="isRequiredNaturalComplianceProfileAttribute('acknowledgements', 'own_account')"
            :label="$t('acknowledgements.own_account')"
            name="acknowledgements.own_account"></BaseInputCheckbox>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import { usePersonalAccountDataState } from '../../../../../utilities/account/useAccountDataPersonal'
import { isRequiredNaturalComplianceProfileAttribute } from '../forms'

const { naturalProfile: account } = usePersonalAccountDataState()
</script>
